import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from "rxjs";

const AUTH_API = '/api/auth/';
const httpOptions = {
  headers: new HttpHeaders({'Content-Type' : 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) {
  }

  getItems(url: string) : Observable<any[]> {
    return this.http.get<any[]>(url);
  }

  getLatestItems(url: string, limit = 8) : Observable<any[]> {
    let params = new HttpParams().append('limit', limit);
    return this.http.get<any[]>(url + '/items/latest', {params: params});
  }

  getCategories(url: string) : Observable<any[]> {
    return this.http.get<any[]>(url + '/categories');
  }

  getCounties(url: string, param: string) {
    return this.http.get(url + param);
  }

  getItemsByName(url: string, itemName : string, county : string, profile?: string | null) {
    let params = new HttpParams();
    params = params.append('itemName', itemName);
    params = params.append('county', county);
    if (profile) {
      params = params.append('profile', profile);
    }
    return this.http.get<any>(url + 'item-name', {params:params});
  }

  getSearchItem(url: string, itemInfo : string) {
    let params = new HttpParams();
    params = params.append('itemInfo', itemInfo);
    return this.http.get(url + 'search-item', {params:params});
  }

  getSearchHeaderItem(url: string, itemShop : any) {
    let params = new HttpParams();
    params = params.append('item', itemShop.item);
    params = params.append('location', itemShop.location);
    params = params.append('subcategory', itemShop.subcategory != null ? itemShop.subcategory : 'undefined');
    params = params.append('category', itemShop.category != null ? itemShop.category : 'undefined');
    return this.http.get(url + 'search-items', {params:params});
  }

  signout(url): Observable<any> {
    return this.http.post(url + AUTH_API + 'signout', httpOptions);
  }
}
